module.exports = __webpack_public_path__ + "static/media/Bankimage.8e5b37e8.svg";